import Footer from '@components/organisms/FooterNew'
import Header from '@components/organisms/Header/Header'
import HeroSection from '@components/pages/advantageous/HeroSection'
import styled from '@emotion/styled'
import DifferentPlatform from '../../components/pages/advantageous/DifferentPlatform'
import ChooseEdugram from '@components/pages/advantageous/ChooseEdugram'
import Edugram500 from '@components/pages/advantageous/Edugram500'
import PublishCourse from '@components/pages/advantageous/PublishCourse'
import Explore from '@components/pages/advantageous/Explore'
import Testimonials from '@components/pages/advantageous/Testimonials'
import FAQSection from '@components/pages/advantageous/FAQSection'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import { useTranslation } from 'next-i18next'
import Head from 'next/head'
import withLenis from '@components/HOCs/LenisWrapper'

type Props = {}

const MainWrapper = styled.div`
  display: flex;
  flex-direction: column;
`
const ChildWrapper = styled.div`
  @media screen and (max-width: 1525px) {
    padding: 0px 0.8rem;
  }
`

const BodyWrapper = styled.div`
  display: flex;
  flex-direction: column;
`

export async function getServerSideProps({ locale }: { locale: string }) {
  return {
    props: {
      ...(await serverSideTranslations(locale, [
        'common',
        'home',
        'authentication',
        'footer',
        'courses',
        'signUp',
        'home',
        'wishlist',
        'cartModal',
        'wishlistDropdown',
        'errors',
        'advantageous',
      ])),
    },
  }
}

const Advantageous = ({}: Props) => {
  const { t } = useTranslation('advantageous')

  const heroSectionData = {
    title: t('heroSection.title'),
    description: t('heroSection.description'),
  }

  return (
    <>
      <Head>
        <title>{t('pageTitle')}</title>
        <meta
          name="description"
          content="Wider Reach. Lasting Experience. Higher Earnings."
        />
        <meta property="og:title" content={t('pageTitle')} />
        <meta
          property="og:description"
          content={'Wider Reach. Lasting Experience. Higher Earnings.'}
        />
      </Head>
      <MainWrapper>
        <ChildWrapper>
          <Header />
        </ChildWrapper>
        <BodyWrapper>
          <HeroSection
            title={heroSectionData.title}
            description={heroSectionData.description}
          />
          <DifferentPlatform />
          <ChooseEdugram />
          <Edugram500 />
          <PublishCourse />
          <Testimonials />
          <FAQSection />
          <Explore />
        </BodyWrapper>
        <ChildWrapper>
          <Footer />
        </ChildWrapper>
      </MainWrapper>
    </>
  )
}

export default withLenis(Advantageous)
